/*
 * Public API Surface of bds-power-bi-embed
 */

export * from './lib/bds-power-bi-embed.component';
export * from './lib/bds-power-bi-embed.module';
